// @ts-nocheck

import { request } from '../../../../context';
import type { ApiOptions } from '../../../../context';
import type { BaseResponseListLlmModelV2App } from '../../../../types';

/**
 * 查询绑定关系
 *
 * @export
 * @tags 租户接口
 * @link [GET] /companys/busi/model/appAndModel
 */
export function getCompanysBusiModelAppAndModel(): Promise<BaseResponseListLlmModelV2App>;
export function getCompanysBusiModelAppAndModel(
    options: ApiOptions<never, never>
): Promise<BaseResponseListLlmModelV2App>;
export function getCompanysBusiModelAppAndModel(
    options?: ApiOptions<never, never>
): Promise<BaseResponseListLlmModelV2App> {
    return request<never, never, never>('/companys/busi/model/appAndModel', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getCompanysBusiModelAppAndModel',
    });
}

export const meta = [
    { tags: ['租户接口'], path: '/companys/busi/model/appAndModel', method: 'get' },
];
